import { Link } from "react-router-dom";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
function ListPagamentiRecenti({ items }) {
  if (!items || items.length === 0) {
    return <div className="alert alert-warning">Nessun pagamento recente</div>;
  }

  return (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th>Utente</th>
            <th>Importo</th>
            <th>Data pagamento</th>
            <th>Ore</th>
            <th>Azioni</th>
          </tr>
        </thead>
        <tbody>
          {items.map((p, i) => (
            <tr
              key={i}
              style={{
                backgroundColor:
                  p.importoTotalePagato === 0 ? "#f2f2f2" : "transparent",
              }}
            >
              <td>{p.utente}</td>

              <td>
                <b>
                  {p.importoTotalePagato === 0 ? (
                    <span className="text-danger fw-bold">Annullato</span>
                  ) : (
                    <span className="text-success fw-bold">
                      {p.importoTotalePagato} €
                    </span>
                  )}
                </b>
              </td>

              <td>{p.dataEsitoSingoloPagamento}</td>

              <td>
                {p.ore
                  ? `${Number(p.ore.replace(",", ".")).toLocaleString("it-IT", {
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 2,
                    })} ore`
                  : "-"}
              </td>
              <td>
                <Link
                  to={`/lista_utenti/dati_utente?citizen=${p.userId}`}
                  className="btn btn-outline-primary p-1 ml-1 btn-block d-inline-flex align-items-center justify-content-center"
                  title="vai all'utente"
                >
                  <svg className="icon icon-primary mr-1">
                    <use href={`${iconSprite}#it-user`} />
                  </svg>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ListPagamentiRecenti;
